module.exports = __webpack_public_path__ + "static/media/icon-goal.3165afaa.svg";